<div class="definition-list">
  <div class="field">
    <label class="field-label">Link target</label>
    <div class="field-content">
      {{sp_select_tag "assessment_id" searchable=true required=true includeBlank=false}}
    </div>
  </div>
</div>
